import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, ExternalLink } from 'lucide-react';
import { contactInfo } from '../mock';

export const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-purple-50 to-white border-t border-purple-100">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-purple-700 rounded-full flex items-center justify-center text-white font-bold text-lg">
                <img src="/images/logo_round.webp" alt="Logo of Jagratha SHG" />
              </div>
              <p>
                <span className="text-lg font-bold text-purple-800">Jagratha SHG</span><br/>                
                <span className="text-sm text-purple-800">Chennaveli, Alappuzha, Kerala</span>
              </p>
            </div>
            <p className="text-gray-600 text-sm leading-relaxed">
              A self-reliant community where every individual has the opportunity to grow economically, socially, and spiritually through cooperative action.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold text-purple-800 mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-600 hover:text-purple-700 transition-colors duration-200 text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-600 hover:text-purple-700 transition-colors duration-200 text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/news-events" className="text-gray-600 hover:text-purple-700 transition-colors duration-200 text-sm">
                  News & Events
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-gray-600 hover:text-purple-700 transition-colors duration-200 text-sm">
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-600 hover:text-purple-700 transition-colors duration-200 text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold text-purple-800 mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3 text-sm">
                <Mail className="text-purple-600 mt-0.5 flex-shrink-0" size={18} />
                <a href={`mailto:${contactInfo.email}`} className="text-gray-600 hover:text-purple-700 transition-colors duration-200">
                  {contactInfo.email}
                </a>
              </li>
              {/* <li className="flex items-start space-x-3 text-sm">
                <Phone className="text-purple-600 mt-0.5 flex-shrink-0" size={18} />
                <a href={`tel:${contactInfo.phone}`} className="text-gray-600 hover:text-purple-700 transition-colors duration-200">
                  {contactInfo.phone}
                </a>
              </li> */}
              {/* <li className="flex items-start space-x-3 text-sm">
                <MapPin className="text-purple-600 mt-0.5 flex-shrink-0" size={18} />
                <span className="text-gray-600">{contactInfo.address}</span>
              </li> */}
            </ul>
          </div>

          {/* Innovation Highlight */}
          <div>
            <h3 className="text-lg font-semibold text-purple-800 mb-4">Driving Digital India Forward</h3>
            <p className="text-gray-600 text-sm mb-4 leading-relaxed">
              We're proud to implement Digital India's vision through complete digital solutions for our SHG, featuring mobile apps and e-bookkeeping for all members. bringing government's digital india vision to self help groups. 
            </p>
            
            <a
              href="https://play.google.com/store/apps/details?id=com.qualisinfosys.shg"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition-colors duration-200 text-sm font-medium"
            >
              <span>Android App</span>
              <ExternalLink size={16} />
            </a>

            <a
              href="https://www.selfhelpgroups.in"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 text-purple-800 px-4 py-2 rounded-lg hover:text-purple-700 transition-colors duration-200 text-sm font-medium"
            >
              <span>Learn more..</span>
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-purple-200">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-600 text-sm">
              © {new Date().getFullYear()} Jagratha SHG. All rights reserved.
            </p>
            <p className="text-gray-600 text-sm">
              Made with <span className="text-red-600">♥</span> in india
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
